import NavbarTsoPq from '@components/Navbar/NavbarTsoPq';
import SnackbarTsoPq from '@components/Snackbar/SnackbarTsoPq';
import { RouteMap } from '@constants/routes';
import { useAppSelector } from '@redux/hooks';
import { selectSnackbar } from '@redux/slices/snackbarSlice';
import { Route, BrowserRouter as Router, Routes } from 'react-router';
import './App.css';
import './i18n/i18nConfig';

//pages
import { useMsal } from '@azure/msal-react';
import { FullscreenPageLayoutTsoPq } from '@components/Grid/GridTsoPq';
import LoadingSpinnerTsoPq from '@components/LoadingSpinners/LoadingSpinnerTsoPq';
import AccessDeniedPage from '@pages/AccessDenied/AccessDeniedPage';
import ManagementPage from '@pages/Administration/ManagementPage';
import { Correlation } from '@pages/Correlation/CorrelationPage';
import { HarmonicBackgroundLevel } from '@pages/HarmonicBackgroundLevel/HarmonicBackgroundLevel';
import Home from '@pages/Home';
import { ImportedMeasurementsOverview } from '@pages/ImportedMeasurementsOverview/ImportedMeasurementsOverview';
import MasterdataManagementPage from '@pages/Masterdata/MasterDataAdministration';
import MeasurementVisualization from '@pages/MeasurementVisualization/MeasurementVisualization';
import MeasurmentExport from '@pages/MeasurmentExport/MeasurmentExport';
import NotFound from '@pages/NotFound';
import PqIndex from '@pages/PqIndex/PqIndex';
import TrendIdentification from '@pages/TrendIdentification/TrendIdentification';
import DetailedViewUploadedFile from '@pages/UploadData/DetailedViewUploadedFile';
import Upload from '@pages/UploadData/UploadDataPage';
import { useGetTsoGetAllQuery } from '@redux/apiSlices/tsoApi';
import { setTsoAbbreviation, setTsoId } from '@redux/slices/tsoIdentificationSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

//testing

function App() {
  const snackbarProps = useAppSelector(selectSnackbar);
  const dispatch = useDispatch();
  const { data: allTsos, isSuccess } = useGetTsoGetAllQuery();
  const { instance } = useMsal();

  const tsoAbbreviation = useAppSelector((state) => state.tsoIdentification.abbreviation);
  const account = instance.getActiveAccount();

  useEffect(() => {
    if (isSuccess && allTsos?.externalDtos) {
      const userTso = allTsos.externalDtos.find((tso: { isLoggedInUsersTso?: boolean }) => tso.isLoggedInUsersTso);

      if (userTso?.id && userTso.abbreviation) {
        dispatch(setTsoId(userTso.id));
        dispatch(setTsoAbbreviation(userTso.abbreviation));
      }
    }
  }, [isSuccess, allTsos, dispatch]);

  // if (!account?.idTokenClaims?.roles) return <AccessDeniedPage />;
  if (allTsos?.externalDtos == null) return <LoadingSpinnerTsoPq />;
  if (allTsos?.externalDtos?.find((t: { isLoggedInUsersTso: any }) => t.isLoggedInUsersTso) === undefined)
    return 'Not authorized';

  return (
    <Router>
      <NavbarTsoPq />
      <Routes>
        <Route path={RouteMap.HOME_ROUTE} element={<Home />} />
        <Route path={RouteMap.UPLOAD_ROUTE} element={<Upload />} />
        <Route path={RouteMap.ADMINISTRATION_ROUTE} element={<ManagementPage />} />
        <Route path={`${RouteMap.ADMINISTRATION_ROUTE}/:type/:deviceId`} element={<ManagementPage />} />
        <Route path={RouteMap.ADMIN_ROUTE} element={<ManagementPage />} />
        <Route path={`${RouteMap.MASTERDATA_ADMINISTRATION_ROUTE}`} element={<MasterdataManagementPage />} />
        <Route path={RouteMap.FILE_DETAIL_ROUTE} element={<DetailedViewUploadedFile />} />
        <Route path={RouteMap.MEASUREMENT_VISUALIZATION} element={<MeasurementVisualization />} />
        <Route path={RouteMap.MEASUREMENT_EXPORT} element={<MeasurmentExport />} />
        <Route path={RouteMap.IMPORTED_MEASUREMENTS_OVERVIEW} element={<ImportedMeasurementsOverview />} />
        <Route path={RouteMap.PQ_INDEX} element={<PqIndex />} />
        <Route path={RouteMap.HARMONIC_BACKGROUND_LEVEL} element={<HarmonicBackgroundLevel />} />
        <Route
          path={RouteMap.CORRELATION}
          element={
            tsoAbbreviation === 'AMP' ? (
              <FullscreenPageLayoutTsoPq>
                <AccessDeniedPage />
              </FullscreenPageLayoutTsoPq>
            ) : (
              <Correlation />
            )
          }
        />
        <Route
          path={RouteMap.TREND}
          element={
            tsoAbbreviation === 'AMP' ? (
              <FullscreenPageLayoutTsoPq>
                <AccessDeniedPage />
              </FullscreenPageLayoutTsoPq>
            ) : (
              <TrendIdentification />
            )
          }
        />
        {/* catch all undefined routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <SnackbarTsoPq {...snackbarProps} autoHideDuration={5000} />
    </Router>
  );
}

export default App;
